import { render, staticRenderFns } from "./TotalEnrolled.vue?vue&type=template&id=9ccee0e4&scoped=true&"
import script from "./TotalEnrolled.vue?vue&type=script&lang=js&"
export * from "./TotalEnrolled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ccee0e4",
  null
  
)

export default component.exports